// Shared CSV cell handling for the dashboard exports.
//
// Excel puts the green "number stored as text" triangle on any quoted cell whose
// contents look like a number, and our rows arrive already display-formatted
// ("1,630.00", "₹9,13,158.75"), so every amount used to land as text. Unwrap
// those back into bare, unquoted numbers and quote only what is genuinely text.

const NUMERIC = /^[+-]?\d+(\.\d+)?$/;

/** The plain number behind a display value, or null when it isn't one. */
export const parseNumericCell = (value) => {
  if (typeof value === 'number') return Number.isFinite(value) ? value : null;
  if (value === null || value === undefined) return null;

  const str = String(value).trim();
  if (!str) return null;
  // A leading zero belongs to an identifier (AWB, S/B number), not to a number.
  if (/^0\d/.test(str)) return null;

  const cleaned = str.replace(/[₹$,\s]/g, '');
  if (!NUMERIC.test(cleaned)) return null;

  const num = Number(cleaned);
  if (!Number.isFinite(num)) return null;
  // Long identifiers lose digits once they go through a float — keep them as text.
  if (!cleaned.includes('.') && String(num) !== cleaned.replace(/^\+/, '')) return null;
  return num;
};

export const normalizeCsvCell = (value) => {
  if (Array.isArray(value)) return value.join(' & ');
  if (value === null || value === undefined) return '';
  return String(value);
};

/** One CSV cell: a bare number when it is one, quoted text otherwise. */
export const escapeCsv = (value) => {
  if (!Array.isArray(value)) {
    const num = parseNumericCell(value);
    if (num !== null) return String(num);
  }
  const str = normalizeCsvCell(value);
  // Already an Excel text escape (="0012") — quoting it would print the formula.
  if (/^="[^"]*"$/.test(str)) return str;
  return `"${str.replace(/"/g, '""')}"`;
};

/** Header row + data rows as a single CSV string. */
export const buildCsv = (headers, rows) =>
  [headers.join(','), ...rows.map((row) => row.map(escapeCsv).join(','))].join('\n');

export default escapeCsv;
